// extracted by mini-css-extract-plugin
export default {"imageWrapper":"ID-z","hovered":"JD-z","hoverImage":"KD-z","mainImage":"LD-z","imageNoBackground":"MD-z","fullSizeImage":"ND-z"};